import { Component, OnDestroy } from '@angular/core';

import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SharedLanguageService } from '@language';
import {
    FieldDefinition,
    FieldReadHelper,
    FormSelectOption,
    GenerateQueryParamsFromAdvancedSearchTerm,
    GenericTypedValue,
    Group,
    NonNullSimpleFieldValue,
    ShMultiItemReadonlyFieldComponent,
    SimpleFieldValue,
    toFormSelectOption,
    UrlQueryParams,
    UserService
} from '@stylehaven/components';
import { SimpleType } from '../../../../common/entities/common/simple-type.entity';
import { MHSearchRoutingService } from '../../../../common/services/common/search-routing.service';

@Component({
    selector: 'med-permissions-readonly-field',
    templateUrl: './permissions-readonly-field.component.html',
    styleUrls: ['./permissions-readonly-field.component.scss']
})
export class PermissionsReadonlyFieldComponent extends ShMultiItemReadonlyFieldComponent implements OnDestroy {
    public typedLabeledValues$: Observable<GenericTypedValue<FormSelectOption<SimpleType>[]>[]>;

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: MHSearchRoutingService,
        protected translateService: SharedLanguageService,
        private readonly userService: UserService
    ) {
        super(fieldHelper, searchRoutingService, translateService);
        this.initValuesStream();
    }

    private initValuesStream(): void {
        const userGroups$: Observable<Group[]> = this.userService.getAssignableUserGroups();

        this.typedLabeledValues$ = combineLatest([this.typedValues$, userGroups$]).pipe(
            map(([typedValues, groups]) =>
                typedValues.map(typedValue => this.convertToFormSelectOptionTypedValue(typedValue, groups))
            )
        );
    }

    private convertToFormSelectOptionTypedValue(
        typedValue: GenericTypedValue<SimpleFieldValue[]>,
        groups: Group[]
    ): GenericTypedValue<FormSelectOption<SimpleType>[]> {
        return {
            type: typedValue.type,
            value: typedValue.value
                .map(groupId => groups.find(group => groupId === group.Id))
                .filter(this.isNotNullOrUndefined)
                .map(group => toFormSelectOption(group.Id, group.Name))
        };
    }

    getSearchRouterParams(fieldDefinition: FieldDefinition, value: NonNullSimpleFieldValue): UrlQueryParams {
        // Never surround with quotes
        return GenerateQueryParamsFromAdvancedSearchTerm(fieldDefinition.DottedKey, [value.toString()]);
    }
}
